module.exports = __webpack_public_path__ + "img/header-icon.16f32e14.png";